export default function setSocialDisplay({display}) {
  document.documentElement.style.setProperty('--showSocial', display);
}